import React from "react";
import { Radio } from "antd";
const AntRadioGroup = Radio.Group;
export default function RadioGroup({
  value,
  field,
  options = [],
  onChange,
  opts = {}
}) {
  return (
    <AntRadioGroup
      name={field}
      onChange={e => onChange(e.target.value)}
      value={value}
      {...opts}
    >
      {options.map(item => (
        <Radio value={item.id} key={item.id} disabled={item.disabled}>
          {item.name}
        </Radio>
      ))}
    </AntRadioGroup>
  );
}
